import { createFileRoute } from "@tanstack/react-router"
import Notice from "@/app/notice/page"

export const Route = createFileRoute("/notice")({
  component: Notice,
})
